import React, { Component } from 'react';
import PropTypes from "prop-types";
import {connect} from "react-redux";
import $ from "jquery";
import {FormattedMessage} from "react-intl";

import Analytics from './../../analytics';

export class HomeMenu extends Component {

  static propTypes = {
    mobileNav: PropTypes.array
  };

  constructor(props) {
    super(props);
    this.state = {
      toggle: false,
    };
  }

  componentWillUnmount() {
    $(document).off('click', this.handleMobileBlur);
  }

  handleItemClick = () => {

  };

  handleBack = () => {
    this.handleToggleDropdown();
  };

  handleToggleDropdown = () => {
    Analytics.sendClickEvent('home-button-dropdown', !this.state.toggle);
    this.setState({
      toggle: !this.state.toggle,
    }, () => {
      this.state.toggle
        ? $(document).on('click', this.handleMobileBlur)
        : $(document).off('click', this.handleMobileBlur)
    })
  };

  handleMobileBlur = (e) => {
    const navClick = e.target.closest('[class*="mobile-home-menu"]');
    const backButtonClick = e.target.closest('.ui-back');
    if (!navClick && !backButtonClick) {
      this.handleToggleDropdown();
    }
  };

  render() {
    // let menu = [{
    //   name: "Return to Website",
    //   url: document.referrer || document.location.href
    // }, ...this.props.mobileNav];

    return (
      <div className="mobile-home-menu">
        {this.props.windowWidth >= 991 ? (
          <button className="mobilebutton mobilebutton--home" onClick={this.handleToggleDropdown}>
            <span className="mobilebutton-text"><FormattedMessage id="homeMenuDesktop"/></span>
          </button>
        ) : (
          <button className="menu-header__right-button menu-header__right-button--home"
                  onClick={this.handleToggleDropdown}>
            <span className="menu-header__right-button-text"><FormattedMessage id="homeMenuMobile"/></span>
          </button>
        )}
        <div className={"mobile-home-menu-dropdown" + (this.state.toggle ? " mobile-home-menu-dropdown--opened" : "")}>
          <div className="mobile-home-menu-dropdown__header">
            <button className="bv-back" onClick={this.handleBack}><FormattedMessage id="homeMenuBack"/></button>
          </div>
          <nav className="mobile-home-menu-dropdown__body">
            <ul className="mobile-home-menu-dropdown__list">
              {this.props.mobileNav.map((mobileNav, index) => {
                return (
                  <li className={"mobile-home-menu-dropdown__list-item"}
                      key={"mobileNav"+index}>
                    <a className="mobile-home-menu-dropdown__list-item__link"
                       href={mobileNav.url}
                       target="_blank"
                       rel="noopener noreferrer">
                      {mobileNav.name}
                    </a>
                  </li>
                )
              })}
            </ul>
          </nav>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (store) => {
  return {
    mobileNav: store.navigationState.mobileNav,
    windowWidth: store.serverState.windowWidth,
  };
};

export default connect(mapStateToProps, {
})(HomeMenu);
